export const POPUP_STYLES = {
  formPopupStyles: {
    maxWidth: '550px',
  },
  formInnerStyles: {
    padding: '0 25px',
  },
  formTitleStyles: {
    padding: '0 25px',
  },

  warningBodyStyles: {
    fontSize: '1rem',
    fontWeight: '600',
  },
  warningContentStyles: {
    marginTop: '35px',
  },
  warningPopupStyles: {
    minHeight: '20vh',
    maxWidth: '500px',
    marginTop: '25px',
    padding: '35px 25px',
  },
};

export default POPUP_STYLES;
